module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-icons-3.45ccfa73.svg";